export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 7_06.568dfe59.jpg";